import React from 'react'
import CurrentUser from './CurrentUser'

const withFeature = Component => props => (
  <CurrentUser
    render={currentUser => (
      <Component
        hasFeature={name =>
          ((currentUser && currentUser.features) || []).includes(name)
        }
        {...props}
      />
    )}
  />
)

export default withFeature



// WEBPACK FOOTER //
// ./src/components/withFeature.js